import axios from "axios";

let serviceBaseUrl = "";

process.env.NODE_ENV === "production"
  ? ['hwxrsystem-html-o.api.leiniao.com'].includes(window.location.hostname) ? (serviceBaseUrl = "https://xr-launcher-api-sg.rayneo.com") : (serviceBaseUrl = "https://xr-launcher-api-sg-t.rayneo.cn")
  : (serviceBaseUrl = "/googleorOtaApi");
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
export default service;